import store from '@/store/index'
import {
  get
} from 'lodash-es'
import customerServiceConfig from '@/config/countryConfig/list/customer-service'
import BrandName from '@/config/countryConfig/list/brand'
import sealPic from '@/config/countryConfig/list/seal-pic'
import {
  getLocale
} from '@/utils/locale';

const country = get(store, 'state.common.country', ''); 
const locale = getLocale();

export function getCustomerServicePhone() {
  return get(customerServiceConfig, `phone.${country}`, '');
}

export function getCustomerServiceMail() {
  return get(customerServiceConfig, `mail.${country}`, '');
}

export function getBrandName(type = 'brand_txt_1') {
  return get(BrandName, `${country}.${type}.${locale}`, '');
}

export function getSealPic() {
  return get(sealPic, `${country}`, '');
}